
import { Component, Vue } from 'vue-property-decorator';
import DeviceLayout from '../../layouts/DeviceLayout.vue';
import PcPage from '../../blocks/PcPage.vue';
import MobilePage from '../../blocks/MobilePage.vue';
import { BY_DOWNLOAD_URLS } from '../../config/downloadUrls';
import { LandingProps } from '../../config/types';

@Component({
  components: { DeviceLayout, PcPage, MobilePage },
})
export default class By01Page extends Vue {
  public landingProps: LandingProps = {
    downloadUrls: BY_DOWNLOAD_URLS,
    hideList: true,
    showAppInfo: true,
    isBaiduDeveloper: false,
    showAddress: true,
  };
}
